<template>
  <section>
    <v-slide-y-transition>
      <v-row v-if="!schoolNotOnList && !schoolNotOnCountry">
        <v-col class="py-0" cols="4">
          <v-text-field
            ref="postcode"
            v-model="search"
            v-validate="'required|min:4|numeric'"
            :error-messages="errors.collect('postcode')"
            label="School postcode"
            hint="Enter a valid Australian postcode"
            data-vv-name="postcode"
            data-vv-as="postcode"
            @input="searchSchool"
            mask="####"
            required
          />
        </v-col>
        <v-col class="py-0" offset="1" cols="7">
          <v-autocomplete
            v-show="
              (!hasResult && loading) ||
                (hasResult && !items.length) ||
                items.length
            "
            ref="schoolList"
            v-model="school"
            v-validate="'required'"
            :error-messages="errors.collect('school')"
            data-vv-validate-on="none"
            data-vv-name="school"
            data-vv-as="School name"
            :items="items"
            :loading="loading"
            :disabled="loading || !hasResult || !items.length"
            :label="schoolAutoCompleteLabel"
            return-object
            @change="chosen"
            :search-input.sync="school_input"
          ></v-autocomplete>
        </v-col>
        <v-col class="py-0" cols="12">
          <span>
            <a href="javascript:void(0)" @click="showSchoolNotOnCountry">
              School not in Australia?
            </a>
            <span v-if="hasResult">
              or
              <a href="javascript:void(0)" @click="showSchoolNotOnList">
                school not in list?
              </a>
            </span>
          </span>
        </v-col>
      </v-row>
    </v-slide-y-transition>
    <v-slide-y-transition>
      <v-row row wrap v-if="schoolNotOnList">
        <v-col class="py-0" cols="4">
          <v-text-field
            ref="postcode"
            v-model="search"
            v-validate="'required|min:4|numeric'"
            :error-messages="errors.collect('postcode')"
            label="School postcode"
            hint="Enter a valid Australian postcode"
            data-vv-name="postcode"
            data-vv-as="postcode"
            @input="searchSchool"
            mask="####"
            required
          />
        </v-col>
        <v-col class="py-0" offset="1" cols="7">
          <v-text-field
            ref="schoolInput"
            v-validate="'required'"
            v-model="school_name"
            :error-messages="errors.collect('school_name')"
            hint="Type your school name here"
            label="School Name"
            data-vv-name="school name"
            @input="chosen"
            required
          />
        </v-col>
        <v-col class="py-0" cols="12">
          <span>
            <a href="javascript:void(0)" @click="showSchoolNotOnCountry">
              School not in Australia?
            </a>
            <span>
              or
              <a
                href="javascript:void(0)"
                @click="showSearchSchoolWithPostcode"
              >
                search for school with postcode?
              </a>
            </span>
          </span>
        </v-col>
      </v-row>
    </v-slide-y-transition>
    <v-slide-y-transition>
      <v-row v-if="schoolNotOnCountry">
        <v-col class="py-0" cols="5">
          <v-select
            v-model="country"
            v-validate="'required'"
            :error-messages="errors.collect('Country')"
            label="Country"
            data-vv-name="Country"
            data-vv-as="country"
            required
            :items="countries"
          ></v-select>
        </v-col>
        <v-col class="py-0" cols="7">
          <v-text-field
            v-model="school_name"
            v-validate="'required'"
            :error-messages="errors.collect('school')"
            label="School Name"
            hint="Enter school name"
            data-vv-name="school"
            data-vv-as="school name"
            @input="chosen"
            required
          />
        </v-col>
        <v-col class="py-0" cols="12">
          <span>
            <a
              href="javascript:void(0)"
              @click="
                resetSchoolInfo()
                ;(schoolNotOnList = false), (schoolNotOnCountry = false)
              "
            >
              School is in Australia?
            </a>
          </span>
        </v-col>
      </v-row>
    </v-slide-y-transition>
  </section>
</template>

<script>
import axios from 'axios'
import Countries from '../../public/countries.json'

export default {
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    value: null
  },
  data() {
    return {
      school_input: null,
      school_name: null,
      country: null,
      school: {},
      search: null,
      items: [],
      loading: false,
      schoolNotOnList: false,
      schoolNotOnCountry: false,
      loadFromAPI: true,
      countries: Countries,
      timer: null,
      hasResult: false
    }
  },
  watch: {
    school_input(newVal, oldVal) {
      if (newVal === null) {
        this.school_input = oldVal
      }
    }
  },
  computed: {
    searching() {
      if (this.search) {
        if (this.search.length > 3) {
          return true
        }
      } else {
        return false
      }
      return false
    },
    schoolAutoCompleteLabel() {
      if (this.hasResult && !this.items.length) {
        return 'No school found in the postcode'
      } else if (!this.hasResult && this.loading) {
        return 'Searching'
      } else {
        return 'School name'
      }
    }
  },
  methods: {
    //setSchoolName(e) {},
    searchSchool() {
      this.hasResult = false
      if (!this.search || this.search.length < 4) {
        this.items = []
        this.reload = true
        return
      }

      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.seachAPI()
      }, 800)
    },
    async seachAPI() {
      if (!this.loadFromAPI) return

      // Items have already been requested
      if (this.loading) return

      this.loading = true

      // Lazily load input items
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_SCHOOL_API_URL}/api/v2/schools`,
          {
            params: {
              postcode: this.search
            }
          }
        )
        let items = []
        for (let item in response.data.data) {
          items.push({
            value: item,
            text: response.data.data[item]
          })
        }
        // this.loadFromAPI = false
        this.items = items
        this.loading = false
        this.hasResult = true
        this.$nextTick(() => this.$refs.postcode.$el.focus())
        if (
          this.items.length === 0 ||
          this.items.filter(e => this.school && e.value === this.school.value)
            .length < 1
        ) {
          this.school = null
        }
      } catch (error) {
        throw error
      }
    },
    chosen() {
      // this.loadFromAPI = false
      this.getInfo()
    },
    enableApiSearch() {
      this.loadFromAPI = true
    },
    showSearchSchoolWithPostcode() {
      this.schoolNotOnList = false
      this.schoolNotOnCountry = false
      this.country = null
      this.school_name = null
      this.getInfo()
    },
    showSchoolNotOnList() {
      // this.resetSchoolInfo()
      this.schoolNotOnList = true
      this.schoolNotOnCountry = false
      this.school = null
      this.school_name = this.school_input
      this.country = 'AU'
      this.getInfo()
      this.$nextTick(() => this.$refs.schoolInput.focus())
    },
    showSchoolNotOnCountry() {
      // this.resetSchoolInfo()
      this.schoolNotOnCountry = true
      this.schoolNotOnList = false
      this.school = null
      this.postcode = null
      this.school_name = this.school_input
      this.getInfo()
    },
    resetSchoolInfo() {
      this.hasResult = false
      this.items = []
      this.school = {}
      this.country = null
      this.postcode = null
      this.search = null
      this.school_input = null
      this.school_name = null
      this.$emit('input', null)
    },
    async validate() {
      let result = await this.$validator.validateAll()
      if (result) this.getInfo()
      return !result ? false : true
    },
    getInfo() {
      // this is not the best way to do it, but the method submit() returns a
      // promise if its not a new school and I did not figure out a why to fix it yet.
      const info = {
        school: this.school,
        postcode: this.search,
        country: this.country,
        name: this.school_name
      }
      this.$emit('input', info)
      return info
    }
  }
}
</script>

<style scoped lang="scss"></style>
